import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ReactiveFormsModule } from "@angular/forms";
import { NgxDropzoneModule } from 'ngx-dropzone';  

//import {
 // FontAwesomeModule,
 // FaIconLibrary
//} from "@fortawesome/angular-fontawesome";
// import { faUpload } from "@fortawesome/free-solid-svg-icons";
//import { AngularFileUploaderModule } from "angular-file-uploader";
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';
// Import containers
import { DefaultLayoutComponent } from './containers';
//import { P404Component } from './components/error/404.component';
//import { P500Component } from './views/error/500.component';
// import { LoginComponent } from './views/login/login.component';
//import { RegisterComponent } from './components/register/register.component';
// import { NgxDropzoneModule } from 'ngx-dropzone';
import { ToastrModule } from 'ngx-toastr';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule 
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';
// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { SharedModule } from './shared/shared.module';
import { SharedService } from './shared/shared.service';
import { AppConfig } from './app.config';
import { HttpClientModule } from '@angular/common/http';
//import { ClientDetailsComponent } from './views/clients/client-details/client-details.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UserComponent } from './user/user.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { AuthService } from '../app/user/auth.service/auth.service.component';
import { AuthGuardService } from './user/auth-guard.service/auth-guard.service.component';
//import { Auth } from './user/auth.service/auth.service.component';
//import { AuthGuard } from './user/auth-guard.service/auth-guard.service.component';
//import { DropZoneComponent } from './drop-zone/drop-zone.component';
//import { DropZoneComponent } from './shared/ngxDropZone/ngx-dropzone/dropzone.component';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
//import { SecurityComponent } from './shared/security/security.component';

@NgModule({
  imports: [ 
    BrowserModule,
    AppRoutingModule,  
    // NgxDropzoneModule,
    HttpClientModule,
    ReactiveFormsModule,
    //FontAwesomeModule,
    //AngularFileUploaderModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    SharedModule,  
    NgxDropzoneModule,
    ToastrModule
    .forRoot({
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      autoDismiss: false,
    }),   
      ],
  declarations: [
    AppComponent,
    APP_CONTAINERS,
    //P404Component,
    //P500Component,
   // LoginComponent,
    //RegisterComponent,
    UserComponent,
    SignInComponent,
    SignUpComponent,
    //Auth.ServiceComponent,
    //AuthGuard.ServiceComponent,
    //DropZoneComponent
    //ClientDetailsComponent  
    //SecurityComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    AuthGuardService, AuthService,
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true
    },
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  },
  
  //SharedService
],
 
  bootstrap: [ AppComponent ]
})
export class AppModule { 
  //constructor(private library: FaIconLibrary) {
   // library.addIcons(faUpload);
 // }
}
